import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from './../../../components/logo';
import WebhookIcon from '@mui/icons-material/Webhook';

export default function DrawerHeader({ open }) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: '62px',
        width: 'initial',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: open ? '20px' : 0,
        paddingRight: open ? '16px' : 0,
        borderBottom: '1px solid var(--appMain100)',
        bgcolor: '#ffffff'
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: open ? 'space-between' : 'center',
          gap: 1
        }}
      >
        {open ? (
          <Logo isIcon={false} sx={{ width: 'auto', height: 32 }} />
        ) : (
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: '9px',
              background: 'linear-gradient(135deg, var(--appMainMain) 0%, var(--appMain700) 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <WebhookIcon sx={{ fontSize: 17, color: '#fff' }} />
          </Box>
        )}
      </Box>
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = {
  open: PropTypes.bool
};
